import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Column from '../../../layout/Column'
import Columns from '../../../layout/Columns'
import IconBedroom from '/public/icons/icon-bedroom.svg'
import IconBathroom from '/public/icons/icon-bathroom.svg'
import IconCouch from '/public/icons/icon-couch.svg'
import Perk from '../components/Perk'
import styles from './styles.module.scss'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { useState } from 'react'
import IconMore from '/public/icons/icon-more.svg'
import Button from '../../../elements/Button'
import isEmpty from 'lodash-es/isEmpty'
import { useRouter } from 'next/router'

const Details = ({
  bedrooms,
  bathrooms,
  common_areas,
  more_information,
  title = false,
  translations
}) => {
  const router = useRouter()
  const { isDesktop, isTablet, isSmallMobile } = useResponsive()
  const [show, setShow] = useState(false)
  let items = !show ? 3 : 99

  if (
    isEmpty(bedrooms) &&
    isEmpty(bathrooms) &&
    isEmpty(common_areas) &&
    isEmpty(more_information)
  ) {
    return
  }

  return (
    <Section className={styles.section} variant={['white', 'p-xl']}>
      <Container>
        <Columns variant={['-distribute-between']}>
          <Column
            variant={[isDesktop && !isSmallMobile && '-pr0']}
            spans={isTablet ? 12 : 6}
          >
            <h2>{title || translations?.title[router.locale]}</h2>

            <div className={styles.content}>
              {bedrooms &&
                bedrooms?.map(
                  (item, index) =>
                    index < items && (
                      <Perk
                        key={`bedroom-key-${index}`}
                        icon={<IconBedroom width={40} height={28} />}
                        {...item}
                      />
                    )
                )}

              {more_information &&
                more_information?.map(
                  (item, index) =>
                    index < items && (
                      <Perk key={`bedroom-key-${index}`} {...item} />
                    )
                )}

              {items < bedrooms?.length && (
                <Button
                  onClick={() => setShow(true)}
                  appendIcon={<IconMore width={21} />}
                  arrow={false}
                  variant={['label', 'color-primary', 'm-t-xl']}
                >
                  {translations?.bedroomOptions[router.locale]}
                </Button>
              )}

              {bedrooms && bathrooms && (
                <div className={styles.separator}></div>
              )}

              {bathrooms?.map(
                (bathroom, index) =>
                  (bathroom.value || bathroom.title) && (
                    <Perk
                      key={`bathroom-${index}`}
                      icon={<IconBathroom width={40} height={28} />}
                      {...bathroom}
                    />
                  )
              )}

              {common_areas && (
                <Perk
                  icon={<IconCouch width={40} height={28} />}
                  value={translations?.commonArea[router.locale]}
                  title={common_areas}
                />
              )}
            </div>
          </Column>
        </Columns>
      </Container>
    </Section>
  )
}

export default Details
